<script>
  import {Server, Sido, Funnels} from "../stores.js";
  import {onMount, onDestroy} from "svelte";

  async function inquirySubmit(e) {
    const isPolicyAgreeRejected = document.querySelector('input[name="policy-agree"]:checked').value === "N";
    if (isPolicyAgreeRejected) {
      alert('개인정보 수집 및 이용에 동의해주세요.');
      return false;
    }

    let option = {
      headers: {'Content-type': 'application/json; charset=UTF-8'},
      method: 'POST',
      body: JSON.stringify(Object.fromEntries(new FormData(e.target))),
    }
    return await fetch($Server + '/inquiry', option)
      .then(async res => await res.json())
      .then(response => {
        if (response.result === 'success') { // success
          alert('정상적으로 접수되었습니다.\n담당자가 확인후 연락드리겠습니다.')
          e.target.reset();
        } else { // failed
          alert('오류가 발생하였습니다.')
        }
      }).catch(error => {
        alert('오류가 발생하였습니다.')
        console.warn(error);
        return false;
      });
  }

  let gugun_items = ['구/군'];
  const selectSido = e => {
    const val = e.target.value;
    gugun_items = val === '' ? ['구/군'] : $Sido[val];
  }

  const floatingBannerDisplay = action => {
    let element = document.getElementById('js-floating-banner');
    let token = 'layout__floating_display_none';
    return action === 'none' ? element.classList.add(token) : element.classList.remove(token);
  }
  onMount(() => floatingBannerDisplay('none'));
  onDestroy(() => floatingBannerDisplay());

  import SubHeader from "../components/SubHeader.svelte";

  let subHeader = {
    bg_pc: '/images/sub_inquiry.png',
    bg_mo: '/images/sub_inquiry_m.png',
    title: '가맹문의',
    dsc: '무인 카페 창업 성공을 위해<br />커피멘토 창업 전문가에게 상담받아 보세요.'
  }
</script>

<SubHeader { ...subHeader }/>

<section class="inquiry">
  <div class="inquiry__agreement">
    <div class="inquiry__header-sub header header_sub">
      <h4 class="header__heading heading heading_level_4">개인정보 수집 · 이용 동의</h4>
      <!--<p class="header__text text">커피 멘토는 고객 불만 해소 및 문의 또는 건의에 대한 답변 전달을 위해 아래와 같이 최소한의 개인정보를 수집·이용합니다.</p>-->
    </div>

    <div class="inquiry__table">
      <div class="inquiry__table-group">
        <div class="inquiry__table-title">수집 목적</div>
        <div class="inquiry__table-desc">
          <span>고객 불만해소,</span>
          <span>문의·건의 답변</span>
        </div>
      </div>
      <div class="inquiry__table-group">
        <div class="inquiry__table-title">수집 항목</div>
        <div class="inquiry__table-desc">
          <span>이름, 전화번호,</span>
          <span>E-MAIL 주소</span>
        </div>
      </div>
      <div class="inquiry__table-group">
        <div class="inquiry__table-title">보유·이용기간</div>
        <div class="inquiry__table-desc">3년간</div>
      </div>
    </div>

    <!--<p class="text text_small">-->
    <!--  커피 멘토는 고객의 소리 서비스 이용에 필요한 최소한의 개인정보 수집·이용에 동의하지 않을 권리가 있으며,-->
    <!--  동의 거부 시 거부한 내용에 대해 서비스가 제한 될수 있습니다.-->
    <!--</p>-->
    <p class="inquiry__agreement-text text text_small">
      커피 멘토는 고객 불만 해소 및 문의 또는 건의에 대한 답변 전달을<span class="_newline" />
      위해 아래와 같이 최소한의 개인정보를 수집·이용합니다.
    </p>

    <div class="inquiry__personal-information-agree">
      <div>
        <input type="radio" id="policy-agree1" name="policy-agree" value="Y" checked >
        <label for="policy-agree1" class="text text_small">개인정보 수집·이용에 동의합니다.</label>
      </div>
      <div>
        <input type="radio" id="policy-agree2" name="policy-agree" value="N">
        <label for="policy-agree2" class="text text_small">개인정보 수집·이용에 동의하지 않습니다.</label>
      </div>
    </div>
  </div>

  <div class="inquiry__form">
    <h3 class="inquiry__form-heading">고객 정보 입력</h3>

    <form id="inquiry-form" name="inquiry-form" method="post" on:submit|preventDefault="{inquirySubmit}">
      <fieldset class="inquiry__form-contents">
        <legend class="inquiry__form-legend">가맹 문의</legend>
        <input type="hidden" name="site" value="COFFEE"/>
        <input type="hidden" name="category" value="BUSINESS">

        <div class="inquiry__form-contents-item">
          <div class="form-contents-item form-contents-item__input-title">성함</div>
          <div>
            <input type="text" name="name" placeholder="이름을 입력해주세요." required>
          </div>
        </div>
        <div class="inquiry__form-contents-item">
          <div class="form-contents-item__input-title">연락처</div>
          <div>
            <input type="tel" name="phone" placeholder="연락처를 입력해주세요.(번호만 입력)" required>
          </div>
        </div>
        <div class="inquiry__form-contents-item">
          <div class="form-contents-item__input-title">이메일</div>
          <div>
            <input type="email" name="email" placeholder="이메일을 입력해주세요." required>
          </div>
        </div>

        <div class="inquiry__form-contents-item">
          <div class="form-contents-item__input-title">가맹희망지역</div>
          <div>
            <select class="inquiry-addr" name="addr1" on:change={selectSido}>
              <option value="">도/시</option>
              {#each Object.entries($Sido) as [item]}
                <option value={item}>{item}</option>
              {/each}
            </select>
            <select class="inquiry-addr" name="addr2">
              {#each gugun_items as item}
                <option value={item}>{item}</option>
              {/each}
            </select>
          </div>
        </div>

        <div class="inquiry__form-contents-item">
          <div class="form-contents-item__input-title">알게된 경로</div>
          <div>
            <select class="inquiry-path" name="funnel">
              <option value="">알게된 경로를 선택해주세요</option>
              {#each $Funnels as item}
                <option value="{item}">{item}</option>
              {/each}
            </select>
          </div>
        </div>

        <div class="inquiry__form-contents-item">
          <div class="form-contents-item__textarea-title">문의 내용</div>
          <div class="form-contents-item__textarea">
            <textarea name="content" required></textarea>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
  <div class="inquiry__form-submit">
    <input class="inquiry__submit-btn" type="submit" value="신청하기" form="inquiry-form"/>
  </div>
</section>
